import {
  Armchair, Wifi, AirVent, Users, Presentation, ConciergeBell, Zap, Printer, Coffee,
  Monitor, Lock, Building2, CalendarClock, Mail, Ticket, Briefcase, MapPin, Shuffle,
  ShieldCheck, KeyRound, Network, SlidersHorizontal,
} from "lucide-react";

export const BRAND = "Kinara Works";
export const OWNER = "Ajay Pratap Singh";
export const PHONE_DISPLAY = "+91 9999377037";
export const PHONE_TEL = "tel:+919999377037";
export const waLink = (text) =>
  `https://wa.me/919999377037?text=${encodeURIComponent(text)}`;
export const WA_DEFAULT = waLink(
  "Hi Ajay, I would like to know more about co-working space at Kinara Works, Noida."
);

const m = (n) => `/media/${n}.webp`;
export const IMG = {
  building: m("building"),
  desksA: m("desks-a"),
  desksB: m("desks-b"),
  desksC: m("desks-c"),
  meetingA: m("meeting-a"),
  meetingB: m("meeting-b"),
  idol: m("idol"),
  floorA: m("floor-a"),
  floorB: m("floor-b"),
};

export const NAV = [
  ["home", "Home"], ["about", "About"], ["workspaces", "Workspaces"],
  ["amenities", "Amenities"], ["locations", "Locations"], ["gallery", "Gallery"], ["contact", "Contact"],
];

export const WORKSPACES = [
  { slug: "hot-desk", name: "Hot Desks", icon: Armchair, img: IMG.floorA, desc: "Flexible seating in our open work zones. Pick a free desk and get straight to work." },
  { slug: "dedicated-desk", name: "Dedicated Desks", icon: Monitor, img: IMG.desksB, desc: "Your own reserved desk in a shared professional environment, ready every day." },
  { slug: "private-cabin", name: "Private Cabins", icon: Lock, img: IMG.meetingB, desc: "Enclosed cabins for focused work and confidential conversations with your team." },
  { slug: "team-office", name: "Team Offices", icon: Building2, img: IMG.floorB, desc: "Ready-to-use offices for startups and growing teams who need a space of their own." },
  { slug: "meeting-room", name: "Meeting Rooms", icon: Users, img: IMG.meetingA, desc: "Professional rooms for client meetings, interviews and team discussions." },
  { slug: "conference-room", name: "Conference Rooms", icon: Presentation, img: IMG.desksC, desc: "Larger rooms for presentations, workshops and important business meetings." },
  { slug: "virtual-office", name: "Virtual Office", icon: Mail, img: IMG.building, desc: "A professional Noida business presence for your company, without a full-time desk." },
  { slug: "day-pass", name: "Day Pass", icon: Ticket, img: IMG.desksA, desc: "Drop in for a single productive day in a professional, fully equipped setting." },
  { slug: "custom-corporate", name: "Custom Corporate Workspace", icon: Briefcase, img: IMG.idol, desc: "A workspace configured around your company's team size and requirements." },
];

export const WHY = [
  { title: "Prime Noida Locations", desc: "Easy-to-access business locations in Sector 132 and Sector 90.", icon: MapPin },
  { title: "Flexible Workspace Options", desc: "Workspace solutions for individuals, startups and larger teams.", icon: Shuffle },
  { title: "Professional Environment", desc: "A modern environment designed for productivity and business growth.", icon: ShieldCheck },
  { title: "Ready-to-Use Offices", desc: "Move into a professional workspace without the complexity of setting up a traditional office.", icon: KeyRound },
  { title: "Networking Opportunities", desc: "Work alongside professionals, entrepreneurs and growing businesses.", icon: Network },
  { title: "Flexible Plans", desc: "Choose workspace options according to your requirements.", icon: SlidersHorizontal },
];

export const AMENITIES = [
  { name: "High-Speed Wi-Fi", icon: Wifi },
  { name: "Air-Conditioned Workspace", icon: AirVent },
  { name: "Comfortable Workstations", icon: Armchair },
  { name: "Meeting Rooms", icon: Users },
  { name: "Conference Facilities", icon: Presentation },
  { name: "Reception Area", icon: ConciergeBell },
  { name: "Power Backup", icon: Zap },
  { name: "Printing & Scanning", icon: Printer },
  { name: "Pantry", icon: Coffee },
];

export const LOCATIONS = [
  { id: "sector-132", no: "132", name: "Urbtech Trade Center", area: "Sector 132, Noida, Uttar Pradesh", img: IMG.building, query: "Urbtech Trade Center, Sector 132, Noida, Uttar Pradesh" },
  { id: "sector-90", no: "90", name: "Alphathum Bhutani", area: "Sector 90, Noida, Uttar Pradesh", img: IMG.floorA, query: "Bhutani Alphathum, Sector 90, Noida, Uttar Pradesh" },
];

export const GALLERY = [
  { src: IMG.building, cap: "Building exterior", ratio: "aspect-[1/1]" },
  { src: IMG.desksA, cap: "Open workstations", ratio: "aspect-[4/5]" },
  { src: IMG.meetingA, cap: "Meeting room", ratio: "aspect-[3/4]" },
  { src: IMG.idol, cap: "Interior details", ratio: "aspect-[4/5]" },
  { src: IMG.floorA, cap: "Work floor", ratio: "aspect-[1/1]" },
  { src: IMG.desksB, cap: "Dedicated desks", ratio: "aspect-[3/4]" },
  { src: IMG.meetingB, cap: "Executive seating", ratio: "aspect-[4/5]" },
  { src: IMG.floorB, cap: "Team seating", ratio: "aspect-[1/1]" },
  { src: IMG.desksC, cap: "Workstation row", ratio: "aspect-[4/5]" },
];

export const CalendarIcon = CalendarClock;
